/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var Job;
(function (Job) {
    let payFrequency;
    (function (payFrequency) {
        payFrequency["HOURLY"] = "HOURLY";
        payFrequency["DAILY"] = "DAILY";
        payFrequency["WEEKLY"] = "WEEKLY";
        payFrequency["BIWEEKLY"] = "BIWEEKLY";
        payFrequency["MONTHLY"] = "MONTHLY";
        payFrequency["ANNUALLY"] = "ANNUALLY";
    })(payFrequency = Job.payFrequency || (Job.payFrequency = {}));
    let currency;
    (function (currency) {
        currency["USD"] = "USD";
        currency["EUR"] = "EUR";
        currency["GBP"] = "GBP";
    })(currency = Job.currency || (Job.currency = {}));
    let employmentType;
    (function (employmentType) {
        employmentType["FULL_TIME"] = "FULL_TIME";
        employmentType["PART_TIME"] = "PART_TIME";
        employmentType["PRN"] = "PRN";
        employmentType["PART_TIME_ON_CALL"] = "PART_TIME_ON_CALL";
        employmentType["CONTRACT"] = "CONTRACT";
        employmentType["TEMPORARY"] = "TEMPORARY";
        employmentType["INTERNSHIP"] = "INTERNSHIP";
        employmentType["VOLUNTEER"] = "VOLUNTEER";
        employmentType["OTHER"] = "OTHER";
    })(employmentType = Job.employmentType || (Job.employmentType = {}));
    let locationType;
    (function (locationType) {
        locationType["REMOTE"] = "REMOTE";
        locationType["ONSITE"] = "ONSITE";
        locationType["HYBRID"] = "HYBRID";
        locationType["OTHER"] = "OTHER";
    })(locationType = Job.locationType || (Job.locationType = {}));
})(Job || (Job = {}));
